<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["add_credit_card"] }}
        </p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["set_credit_card_info"] }}
      </p>
      <input
        type="tel"
        v-mask="'################'"
        v-model="number"
        :placeholder="this.$store.getters.TRANSLATIONS['credit_card_number']"
        class="number"
        autocomplete="off"
      />
      <div class="card-wrapper">
        <input
          type="tel"
          v-mask="'##/##'"
          v-model="expire"
          :placeholder="this.$store.getters.TRANSLATIONS['mm_yy']"
          class="expire"
          autocomplete="off"
        />
        <input
          type="tel"
          v-mask="'####'"
          v-model="cvv"
          :placeholder="this.$store.getters.TRANSLATIONS['cvv']"
          class="cvv"
          autocomplete="off"
        />
        <input
          v-mask="'XXXXXX'"
          v-model="zip"
          :placeholder="this.$store.getters.TRANSLATIONS['postal_code']"
          class="zip"
          inputmode
          v-uppercase
        />
      </div>
      <div class="rest-text">
        {{ this.$store.getters.TRANSLATIONS["*rest_assured"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["details_on_this_website"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["stored_by_authorize"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["payment_gateway"] }}
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="addCard()" class="button">
        {{ this.$store.getters.TRANSLATIONS["save"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      number: "",
      expire: "",
      cvv: "",
      zip: "",
      addCard: () => {
        let error;
        if (!this.validateCardNumber(this.number)) {
          error = this.$store.getters.TRANSLATIONS["no_valid_card_number"];
        }
        if (!this.validateMMDD(this.expire)) {
          error = this.$store.getters.TRANSLATIONS["no_valid_expire_date"];
        }
        if (!this.zip) {
          error = this.$store.getters.TRANSLATIONS["not_valid_zip"];
        }
        if (!this.validateCVV(this.cvv)) {
          error = this.$store.getters.TRANSLATIONS["not_valid_cvv"];
        }
        if (error) {
          this.$modal.show("dialog", {
            text: error,
            buttons: [
              {
                title: "OK"
              }
            ]
          });
        } else {
          const timeout = setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$http
            .post(
              `${process.env.SERVER_URL}/6BFA0C260A2349D7808802D2ACF218CB`,
              {
                number: this.number,
                expire: this.expire,
                cvv: this.cvv,
                zip: this.zip
              },
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              console.log("Add card response");
              console.log(response);
              if (response.data && response.status && response.status === 200) {
                if (this.$route.query.returnTo) {
                  this.$router.push(`/${this.$route.query.returnTo}`);
                } else {
                  this.$router.push("/cardsListSquare");
                }
              }
            })
            .catch((error) => {
              let text =
                this.$store.getters.TRANSLATIONS["something_went_wrong"];
              if (
                error.response &&
                error.response.data &&
                error.response.data.error
              ) {
                text = error.response.data.error;
              }
              this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK",
                    handler: () => {
                      // this.$storage.remove("parkendaToken");
                      // this.$router.push("/login");
                      this.$modal.hide("dialog");
                    }
                  }
                ]
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.loading = false;
            });
        }
      },
      addCardSkip: () => {
        this.$router.push("/parkendaValet");
      },
      back: () => {
        if (this.$route.query.returnTo) {
          this.$router.push(`/${this.$route.query.returnTo}`);
        } else {
          this.$router.push("/payWithSquareUpCreditCard");
        }
      },
      icon: require("@/assets/icon_back.png")
    };
  },
  methods: {
    validateCardNumber: (email) => {
      const re =
        /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
      return re.test(email);
    },
    validateMMDD: (MMDD) => {
      const re = /^(0?[1-9]|1[0-2]){1}\/(0?[1-9]|1[0-9]|2[0-9]|3[0-1]){1}$/;
      return re.test(MMDD);
    },
    validateZip: (zip) => {
      const re = /^[0-9]{5}(?:-[0-9]{4})?$/;
      return re.test(zip);
    },
    validateCVV: (CVV) => {
      const re = /^[0-9]{3,4}$/;
      return re.test(CVV);
    }
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
input {
  background: transparent !important;
  color: rgba(114, 174, 255, 1) !important;
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
.number {
  margin: 0 17vw;
}
.card-wrapper {
  display: grid;
  grid-template-columns: 32% 32% 32%;
  grid-gap: 5px;
  margin: 5vh 17vw;
}
.rest-text {
  color: gray;
  text-align: left;
  margin: 2vh auto;
  font-size: 3.5vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/Add.vue